

import React from 'react';
import { CalculatorCategory } from '../lib/calculatorUtils';
import { Calculator, DollarSign, Heart, Briefcase } from 'lucide-react';
import { Link } from 'react-router-dom';

interface CategoryCardProps {
  category: CalculatorCategory;
}

const CategoryCard: React.FC<CategoryCardProps> = ({ category }) => {
  const getIcon = () => {
    switch (category.icon) {
      case 'dollar-sign':
        return <DollarSign className="h-6 w-6" />;
      case 'heart':
        return <Heart className="h-6 w-6" />;
      case 'calculator':
        return <Calculator className="h-6 w-6" />;
      case 'briefcase':
        return <Briefcase className="h-6 w-6" />;
      default:
        return <Calculator className="h-6 w-6" />;
    }
  };

  const themeClasses = {
    finance: 'bg-finance/10 text-finance hover:bg-finance/20 border-finance/20',
    health: 'bg-health/10 text-health hover:bg-health/20 border-health/20',
    everyday: 'bg-everyday/10 text-everyday hover:bg-everyday/20 border-everyday/20',
    education: 'bg-everyday/10 text-everyday hover:bg-everyday/20 border-everyday/20',
    lifestyle: 'bg-everyday/10 text-everyday hover:bg-everyday/20 border-everyday/20',
    professional: 'bg-professional/10 text-professional hover:bg-professional/20 border-professional/20'
  };

  // Use the actual category ID for the URL path to match the route definitions
  const categoryPath = category.id;

  return (
    <div 
      className={`rounded-xl p-6 border transition-all duration-300 
        hover:shadow-lg hover:-translate-y-1
        ${themeClasses[category.theme]} group animate-fade-in`}
    >
      <div className="flex items-center gap-4 mb-3">
        <div className={`p-2.5 rounded-lg 
          ${category.theme === 'finance' ? 'bg-finance text-white' : 
            category.theme === 'health' ? 'bg-health text-white' : 
            category.theme === 'professional' ? 'bg-professional text-white' : 
            'bg-everyday text-white'}`}>
          {getIcon()}
        </div>
        <h3 className="text-xl font-semibold">{category.name}</h3>
      </div>
      
      <p className="text-muted-foreground mb-4">{category.description}</p>
      
      <div className="flex gap-2 flex-wrap">
        {category.calculators.map((calc) => (
          <Link
            key={calc.id}
            to={`/calculators/${categoryPath}/${calc.id}`}
            className={`text-sm px-3 py-1.5 rounded-md bg-white/70 dark:bg-black/10 transition-all duration-300
              hover:scale-105 hover:shadow-sm min-h-[36px] flex items-center
              ${category.theme === 'finance' ? 'text-finance' : 
                category.theme === 'health' ? 'text-health' : 
                category.theme === 'professional' ? 'text-professional' :
                'text-everyday'}`}
          >
            {calc.name}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CategoryCard;

